<script setup lang="ts">
defineProps<{
  formError?: boolean;
}>();
</script>

<template>
  <div
    v-if="formError"
    id="formErrorMessage"
  ></div>
</template>
